module.exports = __webpack_public_path__ + "img/highroller_320.269b5e04.png";